import { DotIndicatorVariant } from './types'

const DOT_INDICATOR_DEFAULT_VARIANT: DotIndicatorVariant = 'default' as const

export { DOT_INDICATOR_DEFAULT_VARIANT }
